module.exports = __webpack_public_path__ + "img/instagram-w.fa90156d.svg";